import React, { PureComponent } from 'react';

import { TextProps } from '@philips-emr/tws-components';
import { AwesomeComponent, ComponentType } from '@philips-emr/tws-core';
import { bool, object } from '@philips-emr/tws-core/lib/component/prop-types';

import { HpmsTextHtmlAPI } from '../../api';

export interface TextHtmlProps extends TextProps {
  overflow: boolean;
  value: string,
  data: string,
}

@AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: HpmsTextHtmlAPI })
export default class HpmsTextHtml extends PureComponent<TextHtmlProps> {

  static propTypes = {
    data: object.notEnumerable(),
    overflow: bool.group('text-html'),
  };

  static defaultProps = {
    overflow: false,
  };

  public state = {
    value: this.props.value,
  };

  render(): any {

    const html = this.props.value;
    const element = document.createElement('div');
    element.innerHTML = html;
    const context = this.props.value ? this.props.value : (this.state.value ? this.state.value : this.props.data);

    const overflow = element.textContent?.split('\\n').join(' ').substring(0, 15).concat('...');

    return (
      <div className="c-text-html__value">
        {!this.props.overflow ?
          <div className="c-text-html__value--width"
            dangerouslySetInnerHTML={{ __html: context }}></div>
          : <div className="c-text-html__value--width"
            dangerouslySetInnerHTML={{ __html: overflow ? overflow : '' }}></div>}
      </div>
    );
  }

}
